import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
export default new Router({
  routes: [
    {
      path: '/',
      redirect: 'authorization'
    },
    {
      path: '/authorization',
      name: 'authorization',
      component: () => import('../views/authorization/authorization'),
      meta: {
        title: '用户授权'
      }
    },
    {
      path: '/exist',
      name: 'exist',
      component: () => import('../views/exist/index'),
      meta: {
        title: '创建信息'
      }
    },
    {
      path: '/childlist',
      name: 'childlist',
      component: () => import('../views/childlist/childlist'),
      meta: {
        title: '信息选择'
      }
    },
    {
      path: '/qrcode',
      name: 'qrcode',
      component: () => import('../views/qrcode/qrcode'),
      meta: {
        title: '体测结果'
      }
    },
    {
      path: '/miniAuth',
      name: 'miniAuth',
      component: () => import('../views/miniPage/authorization'),  // mini授权
      meta: {
        title: '用户授权'
      }
    },
    {
      path: '/result',
      name: 'result',
      component: () => import('../views/result/result'),  // pc体侧报告
      meta: {
        title: '体测报告'
      }
    },
    {
      path: '/report',
      name: 'report',
      component: () => import('../views/report/report'),   // h5体侧报告
      meta: {
        title: '体测报告'
      }
    },
    {
      path: '/existlogin',
      name: 'existlogin',
      component: () => import('../views/exist/login'),   // 体测报告登录
      meta: {
        title: '体测报告登录'
      }
    },
    {
      path: '/somatosensory',
      name: 'somatosensory',
      component: () => import('../views/somatosensory/somatosensory'),   // 体感报告
      meta: {
        title: '体感报告'
      }
    },
    {
      path: '/somatosensorys',
      name: 'somatosensorys',
      component: () => import('../views/somatosensory/somatosensorys'),   // pc体感报告
      meta: {
        title: '体感报告'
      }
    },
    {
      path: '/shareSomato',
      name: 'shareSomato',
      component: () => import('../views/somatosensory/shareSomato'),   // 分享的体感报告
      meta: {
        title: '体感报告'
      }
    },
    {
      path: '/shareImage',
      name: 'shareImage',
      component: () => import('../views/somatosensory/shareImage'),   // 分享的体感报告
      meta: {
        title: '体感报告'
      }
    },
    {
      path: '/mpshareSomato',
      name: 'mpshareSomato',
      component: () => import('../views/somatosensory/mpshareSomato'),   // 生成小程序分享的图片和二维码
      meta: {
        title: ''
      }
    },
    {
      path: '/userization',
      name: 'userization',
      component: () => import('../views/userization/userization'),   // 体感报告的授权
      meta: {
        title: '用户授权'
      }
    },
    {
      path: '/customer',
      name: 'customer',
      component: () => import('../views/customer/customer'),  
      meta: {
        title: '招生客咨'
      }
    },
    {
      path: '/investment',
      name: 'investment',
      component: () => import('../views/customer/investment'),  
      meta: {
        title: '成为合伙人'
      }
    },
    {
      path: '/studytourSummer',
      name: 'studytourSummer',
      component: () => import('../views/registration/studytourSummer'),  
      meta: {
        title: '研学夏令营报名入口'
      }
    },
    {
      path: '/cluedata',
      name: 'cluedata',
      component: () => import('../views/cluedata/cluedata'),
      meta: {
        title: '线索信息'
      }
    },
    {
      path: '/official',
      name: 'official',
      component: () => import('../views/official/official'),
      meta: {
        title: '公众号授权'
      }
    },
    {
      path: '/signIn',
      name: 'signIn',
      component: () => import('../views/signIn/signIn'),
      meta: {
        title: '考生登录'
      }
    },
    {
      path: '/examination',
      name: 'examination',
      component: () => import('../views/examination/examination'),
      meta: {
        title: '我的考试'
      }
    },
    {
      path: '/exam',
      name: 'exam',
      component: () => import('../views/exam/exam'),
      meta: {
        title: '我的考试'
      }
    },
    {
      path: '/examinationEnd',
      name: 'examinationEnd',
      component: () => import('../views/examinationEnd/examinationEnd'),
      meta: {
        title: '考试结束'
      }
    },
    {
      path: '/heartrate',
      name: 'heartrate',
      component: () => import('../views/heartrate/heartrate'),
      meta: {
        title: '心率报告'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js